<script setup lang="ts">
import type { StickerFill, StickerSize, StickerTilt } from './SfgSticker.vue'

withDefaults(defineProps<{
  bottomLine?: string
  fill?: StickerFill
  flat?: boolean
  scale?: number | string
  size?: StickerSize
  tag?: string
  tilt?: StickerTilt
  topLine?: string
}>(), {
  bottomLine: undefined,
  fill: 'yellow',
  flat: false,
  scale: undefined,
  size: 'md',
  tag: undefined,
  tilt: 1,
  topLine: undefined,
})
</script>

<template>
  <SfgSticker
    :fill
    variant="banner"
    :tilt
    :size
    :scale
    :flat
    :dashed="flat ? false : undefined"
  >
    <div class="px-8 py-6 text-center">
      <div
        v-if="topLine"
        class="font-display-alt leading-none"
        :class="[size === 'lg' ? 'text-[56px]' : size === 'sm' ? 'text-sticker-md' : 'text-sticker-lg']"
      >
        {{ topLine }}
      </div>
      <div
        v-if="bottomLine"
        class="font-display leading-none mt-1"
        :class="[size === 'lg' ? 'text-[38px]' : size === 'sm' ? 'text-sticker-sm' : 'text-sticker-md']"
      >
        {{ bottomLine }}
      </div>
      <div
        v-if="tag"
        class="mt-3 font-body font-bold uppercase"
        :class="[size === 'sm' ? 'text-[10px]' : 'text-[11px]']"
        style="letter-spacing: 0.16em"
      >
        {{ tag }}
      </div>
    </div>
  </SfgSticker>
</template>
